import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import apiClient from '../utils/api';
import '../styles/auth.css';

export const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';

  const [form, setForm] = useState({ password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  if (!token) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h1>Logistics Platform</h1>
          <h2>Invalid Link</h2>
          <div className="error-message">This reset link is invalid or has expired.</div>
          <div className="auth-footer"><Link to="/forgot-password">Request a new link</Link></div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (form.password !== form.confirm) {
      setError('Passwords do not match.');
      return;
    }
    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(form.password)) {
      setError('Password must contain uppercase, lowercase, and a number.');
      return;
    }

    setLoading(true);
    try {
      await apiClient.resetPassword(token, form.password);
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to reset password. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h1>Logistics Platform</h1>
          <h2>Password Reset</h2>
          <div style={{ background: '#dcfce7', color: '#166534', padding: '12px 14px', borderRadius: 6, marginBottom: 20, fontSize: 14 }}>
            Your password has been reset successfully.
          </div>
          <div className="auth-footer"><Link to="/login">Sign in with your new password →</Link></div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Logistics Platform</h1>
        <h2>Reset Password</h2>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="password">New Password *</label>
            <input
              type="password" id="password" value={form.password}
              onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
              required placeholder="Min 8 chars, upper + lower + number"
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirm">Confirm New Password *</label>
            <input
              type="password" id="confirm" value={form.confirm}
              onChange={e => setForm(p => ({ ...p, confirm: e.target.value }))}
              required placeholder="••••••••"
            />
          </div>
          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>

        <div className="auth-footer">
          <Link to="/login">← Back to Login</Link>
        </div>
      </div>
    </div>
  );
};
